<template>
    <div>
        <v-row no-gutters class="mb-n1">
            <v-col>
                <HbTextField
                    class="align-left"
                    search
                    v-model="logSearch"
                    placeholder="Search"
                    style="max-width:300px;"
                    :disabled="fetchingActivityLogs"
                />
            </v-col>
            <v-col>
                <div class="align-right">
                    <hb-modal
                        v-model="filterModal"
                        title="Filter Activity Logs"
                    >
                        <template v-slot:activator>
                            <div class="my-2">
                                <hb-btn icon :active="filterModal" tooltip="Filter">mdi-filter-variant</hb-btn>
                            </div>
                        </template>
                        <template v-slot:subheader>
                            Select the options for filtering the activity logs
                        </template>
                        <template v-slot:content>
                            <hb-form label="Limit">
                                <hb-text-field
                                    class="mb-n2"
                                    condensed
                                    box
                                    medium
                                    v-model="limit"
                                    placeholder="Limit"
                                    v-validate="'numeric'"
                                    id="limit"
                                    name="limit"
                                    data-vv-scope="filter"
                                    :error="errors.has('filter.limit')"
                                >
                                </hb-text-field>
                            </hb-form>
                            <hb-form
                                label="Date Range"
                                description="Select the start and end date of gate activity"
                                :divider="false"
                            >
                                <v-row no-gutters class="my-n1">Select a start and end date.</v-row>
                                <v-row no-gutters>
                                    <v-col cols="6" no-gutters>
                                        <hb-date-picker
                                            v-model="startDate"
                                            @click:clear="startDate = ''"
                                            label="Select Start Date"
                                            :max="endDate ? endDate : todaysDate"
                                            :single-line="true"
                                            :clearable="true"
                                            :solo="false"
                                            data-vv-name="start_date"
                                            data-vv-as="Start Date"
                                        ></hb-date-picker>
                                    </v-col>
                                    <v-col cols="6" no-gutters class="pl-3">
                                        <hb-date-picker
                                            v-model="endDate"
                                            @click:clear="endDate = ''"
                                            label="Select End Date"
                                            :max="todaysDate"
                                            :min="startDate ? startDate : ''"
                                            :single-line="true"
                                            :clearable="true"
                                            :solo="false"
                                            data-vv-name="end_date"
                                            data-vv-as="End Date"
                                        ></hb-date-picker>
                                    </v-col>
                                </v-row>
                            </hb-form>
                        </template>
                        <template v-slot:left-actions>
                            <hb-link v-if="hasFilters && !fetchingActivityLogs" @click="resetFilters()">Reset Filters</hb-link>
                        </template>
                        <template v-slot:right-actions>
                            <hb-btn :disabled="fetchingActivityLogs" @click="refreshActivityLogs">Filter</hb-btn>
                        </template>
                    </hb-modal>
                </div>
            </v-col>
        </v-row>

        <hb-data-table
            :headers="activitiyLogHeaders"
            :items="gateActivityLogs"
            :items-per-page="20"
            :disable-pagination="false"
            :hide-default-footer="false"
            :loading="fetchingActivityLogs"
            :search="logSearch"
            loading-text="Retrieving Activity Log..."
        >
            <!-- <template v-slot:item.property="{ item }">
                {{ item.Property.Address.address }}
                <span v-if="item.end_date"> - {{item.end_date | formatDate}}</span>
            </template>  -->
            <template v-slot:item.unit="{ item }">
                <HbSpaceIcon small :type="item?.unit?.type || 'default'" color="#101318"  />
                {{ item?.unit?.number }}
            </template>
            <template v-slot:item.contact_name="{ item }">
                {{ item?.contact_name }}
            </template>
            <template v-slot:item.date_of_event="{ item }">
                {{ item.date_formatted }}
            </template>
            <template v-slot:item.event_type="{ item }">
                {{ item.event_type }}
            </template>
            <template v-slot:item.event_description="{ item }">
                <div class="my-2">
                    {{ item.event_description }}
                </div>
            </template>
            <template v-slot:item.gate_description="{ item }">
                {{ item.gate_description }}
            </template>
            <template v-slot:item.entered_code="{ item }">
                {{ item.entered_code }}
            </template>
        </hb-data-table>

    </div>
</template>


<script type="text/babel">

import HbDatePicker from '../assets/HummingbirdDatepicker';
import { notificationMixin } from  '../../mixins/notificationMixin.js';
import api from '../../assets/api.js';
import moment from 'moment';

export default{
        name: "GateActivityLog",
        mixins: [ notificationMixin ],
        data(){
            return {
                activitiyLogHeaders: [
                    // { text: 'Property', value: 'property' },
                    { text: 'Space', value: 'unit', width: '100px', sortable: false  },
                    { text: 'Contact', value: 'contact_name', width: '100px', sortable: false  },
                    { text: 'Date & Time', value: 'date_of_event', width: '140px', sortable: true  },
                    { text: 'Event Type', value: 'event_type', width: '140px', sortable: false  },
                    { text: 'Event Description', value: 'event_description', width: '230px', sortable: false  },
                    { text: 'Gate Description', value: 'gate_description', width: '140px', sortable: false  },
                    { text: 'Code Entered', value: 'entered_code', width: '90px', sortable: false  },
                ],
                fetchingActivityLogs: false,
                gateActivityLogs: [],
                filterModal: false,
                todaysDate: '',
                startDate: '',
                endDate: '',
                defaultLimit: 20,
                limit: '',
                refreshTimeout: null,
                logSearch: ''
            }
        },
        props: {
            propertyId:{
                type: String
            },
            contactId: {
                type: String
            },
            initialLimit: {
                type: Number
            }
        },
        components:{
            HbDatePicker
        },
        mounted(){
            this.refreshActivityLogs()
            this.todaysDate = moment.endOf('day').format('YYYY-MM-DD');
        },
        destroyed(){
            if (this.refreshTimeout) {
                clearTimeout(this.refreshTimeout);
            }
        },
        computed:{
            hasFilters() {
                return (this.startDate || this.endDate || this.limit)
            },
            startDatetimeUtc() {
                return this.startDate ? this.convertDateToDatetimeUtc(this.startDate) : null
            },
            endDatetimeUtc() {
                return this.endDate ? this.convertDateToDatetimeUtc(this.endDate) : null
            }
        },
        methods:{
            async fetchGateActivityLog(){
                const filterValidated = await this.$validator.validateAll('filter');
                if (!filterValidated) {
                    this.showMessageNotification({ type: 'error', description: 'There are errors in your filter, correct them before continuing.', list: this.errors.items });
                    return
                }
                if(this.propertyId){
                    try {
                        this.fetchingActivityLogs = true;
                        this.gateActivityLogs = []
                        let url = `${api.ACCESS_CONTROL}properties/${this.propertyId}/gate-activity-logs`

                        let defaultLimit = this.initialLimit || this.defaultLimit
                        let limitNum = parseInt(this.limit)
                        let queryLimit = (!isNaN(limitNum)) ? this.limit : defaultLimit

                        let params = {
                            hb_contact_id: this.contactId,
                            limit: queryLimit
                        }
                        if (this.startDatetimeUtc) params.start_date = this.startDatetimeUtc
                        if (this.endDatetimeUtc) params.end_date = this.endDatetimeUtc

                        let paramsList = Object.keys(params);
                        if (paramsList.length) {
                            url += '?'
                            for (let key in paramsList) {
                                let searchParamKey = paramsList[key]
                                let searchParam = params[searchParamKey]
                                url+= `${searchParamKey}=${searchParam}`
                                if (paramsList[parseInt(key) + 1]) url += '&'
                            }
                        }
                        
                        let r = await api.get(this, url);
                        if (r?.gateActivityLogs?.length) {
                            let activityLogs = r.gateActivityLogs.map((activityLog) => ({
                                ...activityLog,
                                date_formatted: this.$options.filters.formatDateTime(activityLog?.date_of_event)
                            }));
                            this.gateActivityLogs = activityLogs
                        }
                    } catch (err){
                        console.log(err);
                        this.showMessageNotification({ type: 'error', description: err });
                    } finally {
                        this.fetchingActivityLogs = false;
                    }
                }
            },
            resetFilters() {
                this.startDate = '';
                this.endDate = '';
                this.limit = '';
            },
            filterClicked() {
                this.filterModal = false;
                this.refreshActivityLogs()
            },
            refreshActivityLogs(){
                this.resetTimer();
                this.fetchGateActivityLog()
            },
            resetTimer() {
                if (this.refreshTimeout) {
                    clearTimeout(this.refreshTimeout);
                }

                this.refreshTimeout = setTimeout(() => {
                    this.refreshActivityLogs();
                }, 60 * 1000); // 1 minute
            },
            convertDateToDatetimeUtc(date) {
                const localDate = moment(date).startOf('day');
                return localDate.utc().format('YYYY-MM-DD HH:mm:ss');
            }
        },
        watch:{
            propertyId() {
                this.refreshActivityLogs()
            }
        }
}


</script>
